function getTrapStack() {
  window._nc_focus_trap ??= [];
  return window._nc_focus_trap;
}
function createTrapStackController() {
  let pausedStack = [];
  return {
    /**
     * Pause the current focus-trap stack
     */
    pause() {
      pausedStack = [...getTrapStack()];
      for (const trap of pausedStack) {
        trap.pause();
      }
    },
    /**
     * Unpause the paused focus trap stack
     */
    unpause() {
      for (const trap of pausedStack) {
        trap.unpause();
      }
      pausedStack = [];
    }
  };
}
export {
  createTrapStackController as c,
  getTrapStack as g
};
//# sourceMappingURL=focusTrap-DmkaYJTC.mjs.map
